import React from 'react';
import { IconSearch, IconClose } from './Icons';

/**
 * Search field only. Category selection now lives in the filter chips
 * next to it, so the duplicate <select> has been removed.
 */
export default function SearchBar({ search, setSearch }) {
  return (
    <div className="search-field" role="search">
      <span className="search-field__icon"><IconSearch /></span>
      <input
        type="search"
        placeholder="Search by name..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        aria-label="Search plants by name"
      />
      {search && (
        <button
          type="button"
          className="search-field__clear"
          onClick={() => setSearch('')}
          aria-label="Clear search"
        >
          <IconClose size={14} />
        </button>
      )}
    </div>
  );
}
